<template>
  <!--关于我们开始-->
  <div class="main-AboutUs backdrop" id="main-AboutUs">
    <p class="operation"><router-link to="/">{{$t('Home')}}</router-link> >> {{$t('AboutUs')}}</p>
    <p class="caption headline">{{$t('AboutUs')}}</p>
    <!--<p class="caption">关于我们</p>-->
    <div class="nav">
      <ul>
        <router-link class="title" to="/mainAboutUs"><li>{{$t('companyProfile')}}</li></router-link>
        <!--<router-link class="title" to="/us_framework"><li>集团架构</li></router-link>-->
        <!--<router-link class="title" to="/us_culture"><li>企业文化</li></router-link>-->
        <!--<router-link class="title" to="/us_glory"><li>资质荣耀</li></router-link>-->
        <router-link class="title" to="/us_environment"><li>{{$t('companyViews')}}</li></router-link>
      </ul>
    </div>
    <router-view/>
  </div>
  <!--关于我们结束-->
</template>

<script>
    export default {
        name: "aboutUs",
      mounted(){

      }
    }
</script>

<style scoped>
  .router-link-exact-active{
    color:  #064C8D !important;
    font-weight: 900;
    border: 1px solid #064C8D !important;
  }
  .nav{
    width: 6rem;
    margin:.2rem auto 0;
  }
  .nav ul{
    display: flex;
  }
  .nav ul .title{
    line-height:30px;
    flex-grow: 1;
    text-align: center;
    border: 1px solid gray;
    margin: 0 .1rem;
    font-size: 12px;
    color: gray;
  }
  .nav ul .title:hover{
    color: #000000;
    font-weight: 600;
  }
  @media screen and (max-width: 1024px) {
  }

  @media screen and (max-width: 768px) {
    .nav{
      width: 14rem;
    }


  }
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue